export default __webpack_public_path__ + "static/media/sticker_med_1.234afd11.png";